import { render, staticRenderFns } from "./FormReadOnly.vue?vue&type=template&id=4c831fa7&"
import script from "./FormReadOnly.vue?vue&type=script&lang=js&"
export * from "./FormReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c831fa7')) {
      api.createRecord('4c831fa7', component.options)
    } else {
      api.reload('4c831fa7', component.options)
    }
    module.hot.accept("./FormReadOnly.vue?vue&type=template&id=4c831fa7&", function () {
      api.rerender('4c831fa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/FormReadOnly.vue"
export default component.exports